import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "revico-api-master" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" APIローディング状態に表示するコンテンツ "),
    ($props.status === $setup.ApiGetLoadAddStatus.loading)
      ? (_openBlock(), _createBlock($setup["ApiLoadingDisplay"], { key: 0 }))
      : ($setup.isApiSuccessContentsDisplay())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createCommentVNode(" API成功時に表示するコンテンツ "),
            _createCommentVNode(" 追加読み込み時の表示は別途で行うため、追加読み込みステータスによってここの領域が表示されないことがないようにする "),
            _renderSlot(_ctx.$slots, "contents")
          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
        : ($props.status === $setup.ApiGetLoadAddStatus.error)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createCommentVNode(" API失敗時に表示するコンテンツ "),
              _createVNode($setup["ApiErrorDisplay"])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          : _createCommentVNode("v-if", true),
    _createCommentVNode(" 追加読み込み分のAPI処理表示 "),
    _createCommentVNode(" 追加読み込み分のAPIローディング状態に表示するコンテンツ "),
    ($props.status === $setup.ApiGetLoadAddStatus.addLoading)
      ? (_openBlock(), _createBlock($setup["ApiLoadingDisplay"], { key: 3 }))
      : ($props.status === $setup.ApiGetLoadAddStatus.addError)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            _createCommentVNode(" 追加読み込み分のAPI失敗時に表示するコンテンツ "),
            _createVNode($setup["ApiErrorDisplay"])
          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
        : _createCommentVNode("v-if", true)
  ]))
}